import React, { ReactNode } from 'react';
import { SectionHeaderContainer, Title } from './styled';

export const SectionHeader: React.FC<{
  title: string;
  rightBlock?: ReactNode;
}> = ({ title, rightBlock }) => (
  <SectionHeaderContainer>
    <Title>{title}</Title>
    {rightBlock && rightBlock}
  </SectionHeaderContainer>
);
